import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const StyledImgBannerWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    position: relative;
    height: 340px;

    img {
        max-width: 480px;
        max-height: 340px;
        margin: 0 auto;
        object-fit: contain;
        ${mq.lt.sm} {
            width: 100%;
        }
    }

    ${mq.md} {
        img {
            max-width: 100%;
        }
    }

    span {
        width: 100% !important;

        img {
            margin-bottom: 10px;
            height: 310px !important;
            display: none;
            object-fit: cover;

            ${mq.gt.sm} {
                height: 340px !important;
                display: block;
            }

            ${mq.sm} {
                width: 90% !important;
                height: 340px !important;
            }
        }
    }

    ${mq.sm} {
        margin-bottom: 8px;
    }
`;

export const StyledProductImageContainer = styled.div`
    width: 100%;
    max-width: 430px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${mq.lt.xl} {
        width: 35%;
    }
    ${mq.lt.lg} {
        width: 100%;
        max-width: 100%;
    }

    .slide-image {
        display: flex;
        position: relative;
        max-width: max(23.43%, 110px);
        max-height: 88px;
        margin: 0 auto;
        height: 88px;

        img {
            object-fit: contain;
        }
    }

    & .swiper-product-container {
        width: 100%;
        ${mq.lt.lg} {
            display: flex;
            justify-content: center;
        }

        button {
            height: 32px;
            width: 32px;
            margin-top: -15px;

            ${mq.lt.md} {
                display: none;
            }
        }

        & .swiper-slide {
            max-height: 90px;
            width: max(23.43%, 110px);
            margin: auto 12px auto max(2.08%, 12px);

            &:hover {
                cursor: pointer;
            }

            &:last-of-type {
                margin-right: 0;
            }
        }

        ${mq.lt.sm} {
            & .swiper-slide {
                width: 100%;
                height: 100%;
                max-height: 340px;
                margin: auto;

                &:last-of-type {
                    margin-right: 0;
                }

                span {
                    width: 100% !important;
                }

                img {
                    max-height: 345px;
                    max-width: 100%;
                }
            }
        }

        ${mq.gt.md} {
            width: 90%;
            margin: auto;
        }
    }

    section .bullets {
        display: none;

        div {
            position: inherit;
            padding: 15px 10px;
        }
    }
`;
